<template>
  <div class="page-container">
    <van-nav-bar
      left-arrow
      fixed
      :title="$route.params.title"
      @click-left="goableBack()"
      :z-index="10"></van-nav-bar>
    <div
      class="page"
      :style="
        $route.params.detailImgs
          ? 'background-image: url(' + $route.params.detailImgs[0] + ')'
          : ''
      ">
      <template v-if="$route.params.detailImgs">
        <img
          class="introduce-img"
          :src="$route.params.detailImgs[1]"
          alt="迎新年活动详情" />
      </template>
      <template v-else>
        <img
          class="introduce-img"
          src="../../assets/img/my-redpack/my_redpack_tips_info_bg.png"
          alt="迎新年活动详情" />
      </template>

      <div v-if="data.length > 0" class="list">
        <div
          v-for="(n, i) of data"
          :key="`canuse-${i}`"
          class="item-bg"
          :class="i == data.length - 1 ? 'last-item' : ''">
          <img
            v-if="isFebruaryActivity(n.createTime)"
            src="../../assets/img/my-redpack/my_open_redpack_bg_2.png"
            alt="红包背景" />
          <img
            v-else
            src="../../assets/img/my-redpack/my_open_redpack_bg.png"
            alt="红包背景" />
          <!-- isReceived 是否已开奖 0 未开奖 1 已开奖 -->
          <div class="btn-bg">
            <template v-if="n.isExpired == true">
              <button class="btn">已过期</button>
            </template>
            <template v-else>
              <button
                v-if="n.isReceived == 0"
                class="btn"
                @click="onOpenRedEnv(n)">
                立即打开
              </button>
              <button v-else class="btn">已开奖</button>
            </template>
          </div>
        </div>
      </div>
      <div v-else class="empty-bg">
        <van-button
          round
          type="danger"
          class="bottom-button"
          @click="investClick"
          >快去认购获取红包吧</van-button
        >
      </div>
    </div>
    <redenvelope-pop
      :visible.sync="showRedenvelopePop"
      :createTime="item.createTime"
      @onOpenClick="onOpenClick"></redenvelope-pop>
  </div>
</template>
  
  <script>
import { Button, Dialog, Empty, Swipe, SwipeItem } from "vant"
import RedenvelopePop from "./redenvelopePop.vue"
import { getNewYearActivityList, operationRedPacket } from "../../api/market"
export default {
  name: "index",
  data: () => ({
    showRedenvelopePop: false,
    data: [],
    item: {}
  }),

  mounted() {
    this.onRefresh()
  },
  methods: {
    isFebruaryActivity(createTime) {
      if (createTime) {
        if (
          this.dateFormat(createTime, "YYYY") == "2023" &&
          this.dateFormat(createTime, "MM") == "02"
        ) {
          return true
        }
      }
      return false
    },
    onRefresh() {
      this.loadData()
    },
    loadData() {
      getNewYearActivityList()
        .then((data) => {
          this.data = data
        })
        .catch((e) => {
          console.info(e)
          this.$toast(e.msg || e.message)
        })
    },
    onOpenClick() {
      operationRedPacket(this.item.id)
        .then((data) => {
          Dialog.confirm({
            title: "温馨提示",
            message:
              "恭喜您获得" + data + "积分，产品起息后可前往‘我的积分’列表查看",
            confirmButtonText: "确定"
          }).then(() => {})
          this.onRefresh()
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
      this.showRedenvelopePop = false
    },
    onOpenRedEnv(item) {
      this.item = item
      this.showRedenvelopePop = true
    },
    // 立即投资
    investClick() {
      this.$router.push("/invest")
    }
  },
  computed: {},
  components: {
    RedenvelopePop,
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Empty.name]: Empty,
    [Dialog.name]: Dialog
  }
}
</script>
  
  <style lang="less" scoped>
.page {
  width: 100%;
  min-height: calc(100vh - 45px);
  background-image: url("../../assets/img/my-redpack/my_redpack_tips_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.introduce-img {
  margin-top: 20px;
  margin-left: 20px;
  width: calc(100% - 40px);
  object-fit: cover;
}
.list {
  margin: 10px 15px 0 15px;
  padding-bottom: 20px;
  overflow-x: scroll;
  overflow-y: hidden;
  height: 223px;
  display: flex;
  .item-bg {
    position: relative;
    margin-right: 10px;
    width: calc(100% - 35px);
    height: 100%;
    img {
      width: calc(50vw - 35px);
      height: 100%;
      object-fit: fill;
    }
    .btn-bg {
      position: absolute;
      left: 0;
      bottom: 8px;
      width: 100%;
      text-align: center;
      .btn {
        background-color: transparent;
        color: rgb(254, 219, 179);
        font-size: 15px;
        font-weight: 600;
        letter-spacing: 3px;
        border: 0;
      }
    }
  }
  .last-item {
    margin-right: 0px;
  }
}
.empty-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 25px;
  padding-bottom: 20px;
  .bottom-button {
    width: 160px;
    height: 40px;
    border: none;
  }
}
</style>